// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__KXQSS","tyre":"style_tyre__D86Ta"};